export default __webpack_public_path__ + "static/media/f5.bf7fc331.jpg";